import type { User } from '../types/auth';

/**
 * Equipe de operação do módulo de Pedidos — espelha o OrdersStaffGate do backend.
 *
 * O Kanban, os clientes e o detalhe do pedido exigiam `role === 'admin'`, e admin
 * neste app é tudo: empresas, billing, módulos, cadeias de provider. Quem produz
 * o lote precisa do Kanban sem receber a configuração do sistema junto.
 *
 * As DUAS condições importam. O e-mail verificado não é decoração: o cadastro é
 * aberto e o login não exige verificação, então o domínio sozinho não prova nada.
 *
 * Isto é conveniência de UI — quem decide é o backend (`orders.staff` +
 * policies). Uma divergência aqui esconde ou mostra um menu, nunca concede
 * acesso.
 */
export const isOrdersStaff = (user: User | null | undefined): boolean => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (!user.emailVerifiedAt) return false;

  const at = user.email?.lastIndexOf('@') ?? -1;
  if (at < 0) return false;

  return user.email.slice(at + 1).toLowerCase() === 'snapfy.ai';
};
